import { ToothOralSurgeryEnum } from "requests";

export const ORAL_SURGERY_OPTIONS = [
  { value: ToothOralSurgeryEnum.Extraction, label: "Extraction" },
  {
    value: ToothOralSurgeryEnum.SubgingivalCrownAmputation,
    label: "Subgingival Crown Amputation"
  },
  {
    value: ToothOralSurgeryEnum.SutureMaterial,
    label: "Suture Material",
    name: "sutureMaterial"
  }
];
